export function displayCellValue(value: unknown): string {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'string' && value.trim() === '') return '-';
  return String(value);
}
